import { ConferenceProvider } from 'api/conferenceProviders'

export default interface MeetingType {
  default: boolean
  duration: number
  locale: string
  name: string
  title: string
  orgMeeting: boolean
  inviteDescription: string
  location: string
  conferenceLink: string
  conferenceType?: ConferenceProvider
  guestNotifications: Record<GuestNotificationTypeEnum, GuestNotification>
  agentAvailabilities?: AgentAvailability[]
  requiredAttributes: Array<string>
}

export interface MeetingTypeWithId extends MeetingType {
  id: string
}

export type MeetingTypeDict = Record<string, MeetingType>

export enum GuestNotificationTypeEnum {
  MEETING_CONFIRMATION = 'MEETING_CONFIRMATION',
  MEETING_REMINDER = 'MEETING_REMINDER',
  MEETING_REMINDER_FOLLOW = 'MEETING_REMINDER_FOLLOW',
}

export type GuestNotifications = Record<
  GuestNotificationTypeEnum,
  GuestNotification
>

export interface GuestNotification {
  delayTime: number
  emailBody: string
  emailSubject: string
  on: boolean
}

export interface AgentAvailability {
  shouldCheckAvailability: boolean
  agentId: number
}
